import { GivePulse } from '../Pulse/GivePulse'
import { Participant } from '@zoom/videosdk'
import { RaisedHand } from '../RaisedHand'
import { UserMic } from './UserMic'
import { useSessionParams } from '../../hooks/useSessionParams'

export const UserTeams = (props: Participant) => {
    const { room } = useSessionParams()

    return (
        <div className="user">
            <div className="top-left">
                <UserMic {...props} />
            <span>{props.displayName}</span>
        </div>
            <div className="top-right">
                <RaisedHand {...props} />
                {room === 'teams' && <GivePulse {...props} />}
            </div>
        </div>
    )
}
